var objSignalDetails = {
    _hideDetails: function (me) {
        /// <summary>
        /// This function hides the details for each signal
        /// </summary>
        me.vcMenu.selection.entries.signals.find(".vc-list-item .col-opt").html("");
    },

    _showDetails: function (me) {
        /// <summary>
        /// This function shows the details for each signal
        /// </summary>
        try {
            if (!me.error) {
                if (me.details == null) return true;

                //if not admin show only docu
                var bDocuOnly = !me.settings.userRights.isAdmin;

                me.vcMenu.selection.entries.signals.find(".col-opt").toggleClass("full", true);

                if (!bDocuOnly) me.vcMenu.selection.entries.signals.find(".col-right .col-opt").html("");

                $.each(me.details, function (key, row) {

                    row.Hardware.Description = row.Hardware.Description == null ? "" : row.Hardware.Description;

                    var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.Main.Id); });

                    if (signals.length > 0) {
                        var signal = $(signals[0]);
                        var obj = $("<div>").html("");

                        if (row.Info.Description.length > 0) obj.append($("<div>").addClass("box float").css("width", "49%").css("margin-right", "2%").html(row.Info.Description));
                        if (row.Hardware.Description.length > 0) obj.append($("<div>").addClass("box float").css("width", "49%").html(row.Hardware.Description));
                        signal.find(".col-left .col-opt").html(obj);
                        if (!bDocuOnly) {
                            //signal.find(".col-right .col-opt").html("");
                            var t = "";
                            if (row.Main.IsSumSignal) t += "<b>" + me.specific.resources.sumSignal + "</b><br/>";
                            if (row.Hardware.Measure !== null) if (!row.Hardware.Measure) t += "Messung inaktiv</br>";

                            t += $.grep(me.data.zstTypes, function (e) { return e.id == row.Main.ZstType })[0].name + "<br/>";

                            signal.find(".col-right .col-opt").append($("<div>").html($("<div>").addClass("box float vc-grid-1col vc-grid-margin-right").html(t)));
                            t = "";
                            if (row.Hardware.Id !== null) {
                                t += $.grep(me.data.hwMeter, function (e) { return e.id == row.Hardware.Blhmid })[0].name + "<br/>";
                            }
                            if (!(row.Main.Varname == "RULE" || row.Main.Varname == "unused")) {
                                t += "Varname: " + row.Main.Varname + "<br/>";
                            }
                            if (row.Main.ValidationDelay !== 0) t += me.specific.resources.delay + ": " + row.Main.ValidationDelay + " x 15-Minuten<br/>";
                            if (row.Main.LongTermDelay !== 0) t += me.specific.resources.delay + ": " + row.Main.LongTermDelay + " Tage<br/>";

                            if (t.length > 0) signal.find(".col-right .col-opt").append($("<div>").html($("<div>").addClass("box float vc-grid-2col vc-grid-margin-right").html(t)));

                            t = "";

                            $.each(row.Addresses, function (i, adr) {
                                t += $.grep(me.data.hwMeterType, function (e) { return e.id == adr.Blhmtid })[0].name + " - ";
                                t += $.grep(me.data.hwMeterFormat, function (e) { return e.id == adr.Blhmfid })[0].name + "<br/>";
                                t += "MKorr:" + me.formatNumber(adr.MKorr, 6);
                                t += "<br/>";
                            });

                            if (t.length > 0) signal.find(".col-right .col-opt").append($("<div>").html($("<div>").addClass("box float vc-grid-1col").html(t)));
                        }
                    }
                });
            }
        } catch (e) { me._writeErr(e); return false; }
        return false;
    }
};


var objSignalPlaus = {

    _showPlausInfo: function (me) {
        /// <summary>
        /// This function fetches the plausbility for each signal
        /// </summary>
        try {
            if (!me.error) {
                if (me.status.busy && me.status.busy.plausInfo) { return; }

                // set a lock for calling get data only once
                me.status.busy = me.status.busy || {};
                me.status.busy.plausInfo = true;

                var dt = me.status.menu.endDate;
                if (dt == null) dt = getCurrentTimestamp();

                // fetch plaus data from db
                if (me.status.dirty.plausList) {
                    me.getData({ typeid: 5, Day: dt, ChartType: me.settings.defaultChart }, function (result) {
                        if (result == null) {
                            me.showMessage(me.resources.err_loadData, true);
                            me.status.busy.plausInfo = false; 
                            return true;
                        }

                        me.status.dcFilters.allSignalPlausibilities = [];
                        me.status.dcFilters.allSignalPlausibilities = JSON.parse(result);
                        objSignalPlaus._fillPlausList(me);
                        me.status.busy.plausInfo = false;
                    });
                } else {
                    // use saved plaus info
                    objSignalPlaus._fillPlausList(me);
                    me.status.busy.plausInfo = false;
                }
            }
        } catch (e) {
            me._writeErr(e);
            me.status.busy.plausInfo = false;
            return false;
        }
        return false;
    },

    _fillPlausList: function (me) {
        /// <summary>
        /// This function appends the plausibility information to each signal in the signal list
        /// </summary>
        try {
            var allSignals = me.vcMenu.selection.entries.signals.find(".vc-list-item");

            me.vcMenu.selection.entries.signals.find(".col-opt-plaus").toggleClass("full", true).addClass("icon-color-warning").html(me.specific.resources.noPlausibilityExist).css("margin-top", "5px").css("margin-bottom", "5px");

            me.status.dcFilters.plausTypes.allShutdowns = [];
            me.status.dcFilters.plausTypes.allDisturbances = [];
            me.status.dcFilters.plausTypes.allOutliers = [];
            me.status.dcFilters.plausTypes.allConstantControls = [];
            me.status.dcFilters.plausTypes.allStandard = [];

            $.each(me.status.dcFilters.allSignalPlausibilities, function (key, row) {
                var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });

                allSignals = $.grep(allSignals, function (e) { return ($(e).data("id") != row.id); });

                if (signals.length > 0) {
                    var signal = $(signals[0]);
                    var plausInfo;

                    if (row.saptid === 124)
                        me.status.dcFilters.plausTypes.allShutdowns.push(row.id);
                    else if (row.saptid === 125)
                        me.status.dcFilters.plausTypes.allDisturbances.push(row.id);
                    else if (row.saptid === 126)
                        me.status.dcFilters.plausTypes.allOutliers.push(row.id);
                    else if (row.saptid === 137)
                        me.status.dcFilters.plausTypes.allConstantControls.push(row.id);
                    else
                        me.status.dcFilters.plausTypes.allStandard.push(row.id);

                    plausInfo = objSignalPlaus._getPlausIcon(me, row.saptid) + " " + row.name + " - ";

                    if (row.enddate == null) {
                        plausInfo += me.specific.resources.since + " " + moment(row.startdate).format('DD.MM.YYYY');
                    } else {
                        plausInfo += moment(row.startdate).format('DD.MM.YYYY') + " - " + moment(row.enddate).format('DD.MM.YYYY');
                    }

                    plausInfo += ", " + "Min/Max: " + me.formatNumber(row.minplaus, 2) + " / " + me.formatNumber(row.maxplaus, 2);

                    // add plaus to each signal
                    signal.find(".col-left .col-opt-plaus").removeClass("icon-color-warning").html(plausInfo);
                }
            });

            objSignalPlaus._getSignalsWithoutPlaus(me, allSignals);
            me.status.dirty.plausList = false;

        } catch (e) { me._writeErr(e); return false; }
    },

    _getSignalsWithoutPlaus: function (me, signals) {
        /// <summary>
        /// This function fetches all ids of signals without any plaus
        /// </summary>
        try {
            me.status.dcFilters.plausTypes.noPlaus = [];
            $.each(signals, function () {
                me.status.dcFilters.plausTypes.noPlaus.push($(this).data("id"));
            });
            return true;

        } catch (e) { me._writeErr(e); return false; }
    },

    _getPlausIcon: function (me, saptid) {
        /// <summary>
        /// This function gets the correct icon for the signal plausibility
        /// </summary>
        try {
            if (!me.error) {
                switch (saptid) {

                case 122: //default plaus
                    return "";
                case 124: //shut down
                    return "<i class='fa fa-power-off'/> ";
                case 125: //disturbance
                    return "<i class='fa-regular fa-exclamation-triangle'/> ";
                case 126: //outlier
                    return "<i class='fa-regular fa-check-circle'/> ";
                case 137: //constant control
                    return "<i class='fa fa-heartbeat'/> ";
                default:
                }
            }
        } catch (e) { me._writeErr(e); return ""; }
        return false;
    },

    _hidePlausInfo: function (me) {
        /// <summary>
        /// This function hides the plaus info in the signal list
        /// </summary>
        try {
            me.vcMenu.selection.entries.signals.find(".vc-list-item .col-opt-plaus").html("").css("margin-top", "0px").css("margin-bottom", "0px");
            return true;
        } catch (e) { me._writeErr(e); return false; }
    }

};


var objSignalTickets = {
    // <summary>
    // This object holds all functions to show in the signal list which signals have an active ticket
    // </summary>
    _fetchOpenTickets: function (me) {
        /// <summary>
        /// This function gets all open tickets for the current project
        /// </summary>
        try {
            me.getData({ typeid: 7 }, function (result) {
                if (result != null) {
                    me.status.dirty.openTickets = result;
                    objSignalTickets._fillOpenTickets(me);
                }
            });

        } catch (ex) { me._writeErr(ex); return false; }
        return false;
    },

    _fillOpenTickets: function (me) {
        /// <summary>
        /// This function sets the ticket icon correctly for all signals
        /// </summary>
        try {
            if (me.status.dirty.openTickets != null) {
                me.visual.find('#lst-signal li').filter(function () {
                    if (me.status.dirty.openTickets.includes($(this).data("id")))
                        $(this).find(".fa-ticket").removeClass("ticket-inactive").css("opacity", "1");
                    else
                        $(this).find(".fa-ticket").removeClass("ticket-inactive").addClass("ticket-inactive").css("opacity", "0.3");
                });
            }

        } catch (ex) { me._writeErr(ex); return false; }
        return false;
    }
};


var objSignalListItems = {
    // <summary>
    // This object holds all functions to show additional signal information in the signal list widget
    // </summary>

    _fetchPlausList: function (me) {
        /// <summary>
        /// This function fetches the plausbility for each signal and appends the plausibility information
        /// </summary>
        try {
            if (!me.error) {
                var dt = me.status.menu.endDate;
                if (dt == null) dt = getCurrentTimestamp();

                me.getData({ typeid: 5, Day: dt, ChartType: me.settings.defaultChart }, function (result) {
                    if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }

                    me.vcMenu.selection.entries.signals.find(".vc-list-item .col-right .col-opt").removeClass("full").html($("<div>").addClass("icon-color-warning").css("font-size", "smaller").html(me.specific.resources.noPlausibilityExist));

                    $.each(JSON.parse(result), function (key, row) {
                        var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });

                        if (signals.length > 0) {
                            var signal = $(signals[0]);
                            var t = objSignalPlaus._getPlausIcon(me, row.saptid) + " <b>" + row.name + "</b> - ";

                            if (row.enddate == null) {
                                t += me.specific.resources.since + " " + moment(row.startdate).format('DD.MM.YYYY');
                            } else {
                                t += moment(row.startdate).format('DD.MM.YYYY') + " - " + moment(row.enddate).format('DD.MM.YYYY');
                            }
                            var obj = $("<div>").html(t + "<br/>");
                            obj.append("Min/Max: " + me.formatNumber(row.minplaus, 2) + " / " + me.formatNumber(row.maxplaus, 2));

                            signal.find(".col-right .col-opt").html(obj);
                        }
                    });
                    me.status.dirty.plausList = false;
                    return true;
                });
                
            }
        } catch (e) { me._writeErr(e); return false; }

        return false;
    },

    _fetchStatus: function (me) {
        /// <summary>
        /// PROTOTYPE - not working yet - This function shall fetch the status for each signal 
        /// </summary>
        try {
            if (!me.error) {
                var dt = me.status.menu.endDate;
                if (dt == null) dt = getCurrentTimestamp();

                me.getData({ typeid: 5, Day: dt, ChartType: me.settings.defaultChart }, function (result) {
                    if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                    me.vcMenu.selection.entries.signals.find(".vc-list-item .col-right .col-opt").removeClass("full").html("");

                    $.each(JSON.parse(result), function (key, row) {
                        var signals = $.grep(me.vcMenu.selection.entries.signals.find(".vc-list-item"), function (e) { return ($(e).data("id") === row.id); });
                        if (signals.length > 0) {
                            var signal = $(signals[0]);
                            signal.find(".col-right .col-opt").html("status coming soon ...");
                            me.status.dirty.status = false;
                        }
                    });
                    return true;
                });
            }
        } catch (e) { me._writeErr(e); return false; }
        return false;
    }

};